import React from 'react';

// Extracted from StudentProfile.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior).
export default function InviteLinkModal({ show, inviteLink, isRegistered, onClose, onCopy }) {
  if (!show) return null;

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal invite-link-modal" onClick={(e) => e.stopPropagation()}>
        <div className="custom-modal-header">
          <h3>Student Invite Link</h3>
          <button className="custom-modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className="custom-modal-body">
          <div className="invite-link-content">
            <div className="invite-link-field">
              <label>Invite Link:</label>
              <div className="link-input-group">
                <input
                  type="text"
                  value={inviteLink}
                  readOnly
                  className="invite-link-input-modal"
                />
                <button
                  type="button"
                  onClick={onCopy}
                  className="copy-link-btn-modal"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                  Copy
                </button>
              </div>
            </div>

            <div className="invite-status">
              <div className={`status-indicator ${isRegistered ? 'registered' : 'pending'}`}>
                {isRegistered ? '✅' : '📧'}
              </div>
              <div className="status-text">
                <strong>Status:</strong> {isRegistered ? 'Student has registered' : 'Pending registration'}
              </div>
            </div>

            <div className="invite-instructions">
              <h4>Instructions:</h4>
              <ol>
                <li>Copy the invite link above</li>
                <li>Send it to the student via email, message, or any preferred method</li>
                <li>The student will use this link to access the registration page</li>
                <li>Once registered, the student can access their dashboard</li>
              </ol>
            </div>
          </div>
        </div>
        <div className="custom-modal-footer">
          <button className="custom-modal-btn confirm-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
